import React from "react";
import * as emotion from "@emotion/react";
import * as ReactDOM from "react-dom";

// Imported external components rely on these scripts
const addImportDependencies = () => {
  // Imported components rely on consuming applications to
  // have some depenedcies defined on the window object.
  // See https://github.com/xometry/component-webpack-prototype/blob/main/.webpack/webpackfile.js#L28
  if (typeof window !== "undefined") {
    window.React = React;
    window.ReactDOM = ReactDOM;
    window.emotionReact = emotion;
  }
};

export { addImportDependencies };